export async function MindfulnessUpdate(
  mindResp,
  mindFecha,
  mindNumses,
  mindObs,
  mindMedio,
  mindTipo,
  mindPract,
  mindPractEsp,
  mindPractSem,
  mindPractTem,
  mindEstado,
  tratamientoId,
  pacienteId,
  mindfulnessId
) {
  const formData = {
    // taxID-mind-mindNumses
    title: `us-${pacienteId}-tr-${tratamientoId}-mind-${mindNumses}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-mind-${mindNumses}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      mindResp: mindResp,
      metaFecha: mindFecha,
      metaPaciente: pacienteId,
      mindNumses: mindNumses,
      mindObs: mindObs,
      mindMedio: mindMedio,
      mindTipo: mindTipo,
      mindPract: mindPract,
      mindPractEsp: mindPractEsp,
      mindPractSem: mindPractSem,
      mindPractTem: mindPractTem,
      mindEstado: mindEstado,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/mindfulness/${mindfulnessId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
